export const selectSideNavIsCollapsed = state => {
  const isCollapsed = state && state.sideNav.collapsed;
  if (isCollapsed === undefined) {
    return true;
  }
  return isCollapsed;
};
